import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import WPAgGrid from "../../packages/WPAgGrid/WPAgGrid";

import DupontDialog from "../../components/DupontDialog";
import createNotification, {
  INFO_NOTIFICATION,
} from "../../components/Notifications";
import { DATA_VISUALISATION_COL_DEF } from "./dataVisualisationTable.config";
import { formatUnitForDisplay } from "../../utils/Utils";

const DataVisualizationTable = ({
  title,
  rows = [],
  open = false,
  onClose,
  isLoading,
  setshowDataVisualizationPopup,
  setTempReferenceValues,
  description,
}) => {
  const { t } = useTranslation();
  const { flow, pressure, feed_quality, permeate_quality, temperature } =
    useSelector((state) => state);
  const [defaultSettingUnit] = useState({
    flow,
    pressure,
    feed_quality: formatUnitForDisplay(feed_quality),
    permeate_quality: formatUnitForDisplay(permeate_quality),
    temperature: formatUnitForDisplay(temperature),
  });
  const dataVisualisationColumn = DATA_VISUALISATION_COL_DEF(
    t,
    defaultSettingUnit,
  );

  const handleReferenceRowClick = (event) => {
    // Format all number values and numeric strings to 2 decimal places
    const formattedData = { ...event?.data };
    Object.keys(formattedData).forEach((key) => {
      const val = formattedData[key];
      if (
        (typeof val === "number" && !isNaN(val)) ||
        (typeof val === "string" && val !== "" && !isNaN(Number(val)))
      ) {
        formattedData[key] = parseFloat(val).toFixed(2);
      }
    });
    // Set firstLoad.current = false in referenceCondition if available
    if (
      typeof window !== "undefined" &&
      window.firstLoadRefForReferenceCondition
    ) {
      window.firstLoadRefForReferenceCondition.current = false;
    }
    setTempReferenceValues(formattedData);
    setshowDataVisualizationPopup(false);
    createNotification(
      INFO_NOTIFICATION,
      t("referenceConditions.referenceUpdated"),
      "",
    );
  };

  return (
    <DupontDialog
      open={open}
      title={title}
      cancelBtnText="Close"
      onClose={onClose}
      maxWidth="xl"
      isOverlayLoader={isLoading}
      customHeight={570}
      subTitle={description}
    >
      <div className="ro-ag-table visualization-table">
        <WPAgGrid
          columnDefs={dataVisualisationColumn}
          rowData={rows}
          tableHeight="380px"
          context={{ handleReferenceRowClick }}
        />
      </div>
    </DupontDialog>
  );
};

export default DataVisualizationTable;
